export * from './rating-rate';
export * from './rating-rate.props';
